<template>
	<div class="list" v-if="members">
		<md-table v-model="members" md-sort="name" md-sort-order="asc" md-card>
			<md-table-toolbar>
				<div class="md-toolbar-section-start">
					<h1 class="md-title">Members</h1>
				</div>
				<form @submit.prevent="searchMemberBtn()" class="md-member-search">
					<div class="search-container">
						<md-field md-clearable class="search-input-field">
							<md-input
								aria-label="Search query"
								v-model="searchMember"
								@keyup.enter="searchMemberList"
								name="searchMember"
								placeholder="Search Member...">
							</md-input>
						</md-field>
						<md-button type="submit" title="Search" class="search-addon-btnstyle-member md-button md-accent md-theme-default">
							<i class="fa fa-search"></i>
						</md-button>
						<md-button
							type="button"
							title="Clear"
							@click="resetSearchMember"
							class="reset-btn md-button md-accent md-theme-default"
							:disabled="!searchMember">
							<i class="fa fa-times"></i>
						</md-button>
					</div>
				</form>
			</md-table-toolbar>
			<md-table-row>
				<md-table-head>Name</md-table-head>
				<md-table-head>Email</md-table-head>
				<md-table-head>Last Request</md-table-head>
				<md-table-head>Last Response</md-table-head>
				<md-table-head>Last Feedback</md-table-head>
			</md-table-row>
			<template v-for="member in members">
				<member :member="member" :key="member._id">Member goes here...</member>
			</template>
			<!-- <div class="w-100 text-center mt-20" >
        <md-button class="md-mini btnplain capitalize card-header" @click="loadMore()" v-if="skip + limit < count">Load More</md-button>
      </div> -->
		</md-table>
		<md-button class="md-fab loadmore-button" v-on:click="loadMore()" v-if="skip + limit < count" aria-label="Load more members">
			<md-tooltip md-direction="left">Load more</md-tooltip>
			<md-icon><font-awesome-icon icon="recycle" /></md-icon>
		</md-button>
	</div>
</template>
<script>
import Member from "./Member";
import API from "../services/API";
export default {
  	name: "Inbox",
  	components: {
    	Member
  	},
  	props: ["view"],
  	data() {
		return {
	  		api: new API(),
	      	members: [],
	      	fullPage: true,
	      	skip: 0,
	      	limit: 100,
	      	count: 0,
			searchMember: ''
    	};
  	},
  	watch: {
    	$route: "loadData"
  	},
  	created() {
    	this.loadData();
    	this.$on("Reload", () => {
      		this.loadData();
    	});
  	},
  	methods: {
    	loadData: async function() {
	      	this.members = [];
	      	this.skip = 0;
	      	this.limit = 100;
	      	this.count = 0;
	      	// console.log("LOADING....", `members/${this.view}`);
			let uri = `members/${this.view}?limit=${this.limit}&skip=${this.skip}`
			if (this.$route.query.term) {
	        	uri = `members/${this.view}&limit=${this.limit}&skip=${this.skip}&fullSearch=true`;
			}
			await this.api.get(uri).then(members => {
	          	this.members = members.data.members;
	          	this.count = members.data.count;
	          	// console.log("got back members", members.data.members);
	        });
	    },
	    async loadMore() {
	      	this.skip = this.skip + this.limit;
	      	if (this.skip < this.count) {
				if (this.$route.query.term) {
					this.view = this.view + '?fullSearch=true';
				}
	        	await this.api.get(`members/${this.view}`, {params: {limit: this.limit, skip: this.skip}, headers: {'x-api-key': JSON.parse(localStorage.authUser)._id}}).then(members => {
	        		if (members.data instanceof Object || members.data instanceof Array) {
		          		this.count = members.data.count;
		          		this.members = [...this.members, ...members.data.members];
		          	}
	        	});
	      	}
	  	},
	  	searchMemberBtn: function() {
		  	if (this.searchMember !== "") {
				var searchParam = this.searchMember.toLowerCase();
				this.$router.push(`/members/search?term=${searchParam}`);
			}
	  	},
	  	searchMemberList: function () {
			if (this.searchMember === "" && this.$route.path !== '/members/all') {
				this.$router.push('/members/all').catch(err => {
				if (err.name !== 'NavigationDuplicated') {
					throw err;
				}
				});
			}
	  	},
		// Clears the search input and routes to the default view
		resetSearchMember() {
			this.searchMember = "";
			if (this.$route.path !== '/members/all') {
				this.$router.push('/members/all').catch(err => {
					if (err.name !== 'NavigationDuplicated') {
						throw err;
					}
				});
			}
		}
  	}
};
</script>



// WEBPACK FOOTER //
// src/components/Members.vue